import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { adminPayoutsReqSchema } from "~/entities/payout";

import { AdminPayouts } from "./Payouts";

export function createAdminPayoutsRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "admin/payouts",
    component: AdminPayouts,
    validateSearch: adminPayoutsReqSchema,
    head: () => ({
      meta: [{ title: "Payouts" }],
    }),
  });
}
